import { TimelineView } from '@/components/shared/timeline'
import { useTimelineQuery } from '@/services/timeline'
import { Alert, Box, CircularProgress } from '@mui/material'

interface PatientTimelineProps {
  patientName: string
  patientHash: string
}

export default function PatientTimeline({ patientName, patientHash }: PatientTimelineProps) {
  const { data: events = [], isLoading, isError } = useTimelineQuery(patientHash, 'patient')

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return (
      <Alert severity='error' sx={{ mx: 2 }}>
        Failed to load timeline. Please try again later.
      </Alert>
    )
  }

  return (
    <TimelineView
      entityName={patientName}
      events={events}
      totalItems={events.length}
      itemsPerPage={12}
      patientHash={patientHash}
      excludedFilters={['Medication Requests', 'CS notes', 'Investigations', 'Order']}
    />
  )
}
